export default "__VITE_ASSET__390efa7e__"